<p-fieldset legend="Add Shell Courses">
    <div class="my-2 py-2 pulsate">  
        <p-message severity="error">🚨&nbsp;Please make sure the shell course code exists in RLMS as well, so as to transfer grades to it successfully when the learner takes the exam with tool.</p-message>  
    </div>
    <p-message severity="info" class="my-2">
        <i class="pi pi-info-circle" style="font-size: 1rem"></i>&nbsp;&nbsp;Course code format eg: SHELL-COURSE-CODE-001
    </p-message>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="flex flex-column gap-3 my-3">
      <div class="flex flex-column gap-1">
        <p-iftalabel>
          <input pInputText id="codeCommon" formControlName="codeCommon" autocomplete="off" fluid
            [ngClass]="{'ng-invalid ng-dirty': form.get('codeCommon')?.invalid && form.get('codeCommon')?.touched}" />
          <label for="codeCommon">Course Code (from RLMS)</label>
        </p-iftalabel>
        @if (form.get('codeCommon')?.invalid && form.get('codeCommon')?.touched) {
          <small class="text-red-500">Course code is required (3-10 characters).</small>
        }
      </div>

      <div class="flex">
        <div class="col-6 flex flex-column">
          <p-iftalabel>
            <input pInputText id="numberRangeFrom" formControlName="numberRangeFrom" type="number" autocomplete="off" fluid
              [ngClass]="{'ng-invalid ng-dirty': form.get('numberRangeFrom')?.invalid && form.get('numberRangeFrom')?.touched}" />
            <label for="numberRangeFrom">Number Range From</label>
          </p-iftalabel>
          @if (form.get('numberRangeFrom')?.invalid && form.get('numberRangeFrom')?.touched) {
            <small class="text-red-500">Number range from is required.</small>
          }
        </div>

        <div class="col-6 flex flex-column">
          <p-iftalabel>
            <input pInputText id="numberRangeTo" formControlName="numberRangeTo" type="number" autocomplete="off" fluid
              [ngClass]="{'ng-invalid ng-dirty': form.get('numberRangeTo')?.invalid && form.get('numberRangeTo')?.touched}" />
            <label for="numberRangeTo">Number Range To</label>
          </p-iftalabel>
          @if (form.get('numberRangeTo')?.invalid && form.get('numberRangeTo')?.touched) {
            <small class="text-red-500">Number range to is required.</small>
          }
        </div>
      </div>

      <div class="flex flex-column gap-1">
        <p-iftalabel>
          <input pInputText id="zeroPadding" formControlName="zeroPadding" type="number" autocomplete="off" fluid
            [ngClass]="{'ng-invalid ng-dirty': form.get('zeroPadding')?.invalid && form.get('zeroPadding')?.touched}" />
          <label for="zeroPadding">Zero padding</label>
        </p-iftalabel>
      </div>
      <div class="flex flex-row gap-1">
        <p-floatlabel variant="on" class="flex-1">
          <textarea pTextarea readonly rows="10" class="w-full font-monospace" style="resize: none;" [value]="shellCoursesPreview()"></textarea>
          <label>Shell Courses</label>
        </p-floatlabel>
      </div>
      
      <p-message severity="error" class="my-2" [class.hidden]="!presentCourseCodes()">
        These course code/s already exist. 🤨
            <div [innerHTML]="presentCourseCodes()"></div>
      </p-message>
      <p-message severity="success" class="my-2" [class.hidden]="!absentCourseCodes()">
        These are available and can be created. 😎
        <div [innerHTML]="absentCourseCodes()"></div>
      </p-message>

      <p-message severity="secondary"> 
        <div class="flex gap-2 justify-content-start">
            <p-button type="button"  severity="info" label="Check Availability" (onClick)="checkAvailability()"  />
           <p-button  type="submit" label="Save" 
           [disabled]="!wasCheckAvailabilityButtonClicked() || 
           absentCourseCodes().length === 0" />
           <p-button  type="button" label="Cancel" severity="secondary" 
           (onClick)="router.navigate(['/shell-courses'])" />
        </div>
      </p-message>
      
    </div>
  </form>
</p-fieldset>
